module.exports = __webpack_public_path__ + "7f10c9c011838d9d4e300da88996a052.pdf";